/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryCampShowResponse } from '../../models/camp-category-camp-show-response';

export interface DeleteCampCategoryCampRemove$Params {
  category: string;
  camp: string;
}

export function deleteCampCategoryCampRemove(http: HttpClient, rootUrl: string, params: DeleteCampCategoryCampRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryCampShowResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteCampCategoryCampRemove.PATH, 'delete');
  if (params) {
    rb.path('category', params.category, {});
    rb.path('camp', params.camp, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryCampShowResponse>;
    })
  );
}

deleteCampCategoryCampRemove.PATH = '/v1/category/{category}/camp/{camp}';
